import React from 'react';
import PropTypes from 'prop-types';

import FanFavouriteCard from 'Components/Cards/FanFavouriteCard';
import SkeletonFanFavouriteCard from 'Components/Utility/Skeleton/SkeletonFanFavouriteCard';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

const FanFavouritesCarousel = ({ hitData }) => {
  if (!hitData) return false;

  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    md: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    lg: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    xl: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    xxl: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  };

  if (Array.isArray(hitData) && hitData.length === 0) {
    return (
      <div>
        <SiteSlider fullWidth sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
          {[...Array(12).keys()].map(fakeHit =>
            <SkeletonFanFavouriteCard
              key={fakeHit}
            />,
          )}
        </SiteSlider>
      </div>
    );
  }

  return (
    <SiteSlider fullWidth sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
      {hitData.map(hit =>
        <FanFavouriteCard
          key={hit.product_id}
          hit={hit}
        />,
      )}
    </SiteSlider>
  );
};

FanFavouritesCarousel.propTypes = {
  hitData: PropTypes.arrayOf(PropTypes.shape({})),
};

FanFavouritesCarousel.defaultProps = {
  hitData: [],
};

export default FanFavouritesCarousel;
